import ShopPicker from './ShopPicker.vue'

export default ShopPicker